import { render } from "./MainCarousel.vue?vue&type=template&id=55b13f52&scoped=true"
import script from "./MainCarousel.vue?vue&type=script&lang=js"
export * from "./MainCarousel.vue?vue&type=script&lang=js"

import "./MainCarousel.vue?vue&type=style&index=0&id=55b13f52&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b13f52"]])

export default __exports__